module.exports = __webpack_public_path__ + "static/media/larry2.31292b4b.mp3";